import { isToday, isTomorrow } from "date-fns";
import { Heading } from "@medoma/components/Heading/Heading";
import styles from "./scheduleDayHeading.module.scss";
import { humanFormat } from "@medoma/models/date-and-time";
import { useLingui } from "@lingui/react/macro";

export const ScheduleDayHeading = ({ date }: { date: Date }) => {
  const { t } = useLingui();
  const dayAndMonth = humanFormat(date, { day: "numeric", month: "long" });

  const weekDay = humanFormat(date, { weekday: "long" });
  const weekdayCapitalized = weekDay.charAt(0).toUpperCase() + weekDay.slice(1);

  const day = isToday(date)
    ? t`Idag`
    : isTomorrow(date)
      ? t`Imorgon`
      : weekdayCapitalized;

  return (
    <header>
      <Heading level="h2" size="h1" className={styles.heading}>
        {day}
        <span className={styles.dayAndMonth}>{dayAndMonth}</span>
      </Heading>
    </header>
  );
};
